import R from "classnames";
import y, { useMemo as b } from "react";
import { s as w } from "../grid.module-BaK_X3T2.mjs";
const r = (t, s) => typeof t == "number" && !isNaN(t) ? t : typeof t == "string" && !isNaN(parseInt(t, 10)) ? parseInt(t, 10) : s, E = y.forwardRef(
  ({
    children: t,
    className: s = "",
    dataTestId: I = null,
    style: i,
    as: p = "div",
    xxs: e,
    xs: a,
    s: d,
    m: l,
    l: m,
    xl: o,
    xxl: g,
    "colStart-xxs": c,
    "colStart-xs": n,
    "colStart-s": f,
    "colStart-m": x,
    "colStart-l": u,
    "colStart-xl": N,
    "colStart-xxl": _,
    ...G
  }, v) => {
    const P = b(
      () => ({
        ...i,
        "--grid-xxs-col": r(e, 12),
        "--grid-xs-col": r(a),
        "--grid-s-col": r(d),
        "--grid-m-col": r(l),
        "--grid-l-col": r(m),
        "--grid-xl-col": r(o),
        "--grid-xxl-col": r(g),
        "--grid-xxs-start": r(c),
        "--grid-xs-start": r(n),
        "--grid-s-start": r(f),
        "--grid-m-start": r(x),
        "--grid-l-start": r(u),
        "--grid-xl-start": r(N),
        "--grid-xxl-start": r(_)
      }),
      [
        u,
        x,
        f,
        N,
        n,
        _,
        c,
        m,
        l,
        d,
        i,
        o,
        a,
        g,
        e
      ]
    );
    return y.createElement(
      p,
      {
        ref: v,
        "data-testid": I,
        ...G,
        className: R(w.grid__item, "grid-item fuse-responsive-grid__item", s),
        style: P
      },
      t
    );
  }
);
E.displayName = "GridItem";
export {
  E as GridItem
};
